export default __webpack_public_path__ + "static/media/loginImage.d73364f3.jpeg";